<div
  class="drop-area"
  [class.disabled]="disabled"
  [class.drop-area-active]="isDropping"
  (drop)="!disabled && dropHandler($event)"
  (dragover)="!disabled && dragOverHandler($event)"
  (dragleave)="!disabled && dragLeaveHandler($event)">
  <div class="file-upload-button">
    <label
      for="media-input"
      class="media-input-container">
      <div>
        <span>{{ label }}</span>
      </div>

      <input
        id="media-input"
        class="hide-file"
        type="file"
        multiple
        [disabled]="disabled"
        [accept]="'image/*, application/pdf'"
        [placeholder]="'Carica media' | translate"
        (change)="!disabled && onFileChange($event)">
    </label>
  </div>
</div>
